import "./Tooltip.scss";

export type TooltipState = {
  node: {
    artist_name: string;
    career_stage: number;
    genres_spotify?: string[];
    genres_strm?: string[];
  };
  clientX: number;
  clientY: number;
};

type Props = {
  state: TooltipState;
};

const Tooltip: React.FC<Props> = ({ state }) => {
  const { node, clientX, clientY } = state;
  const spotifyGenres = node.genres_spotify || [];
  const strmGenres = node.genres_strm || [];

  return (
    <div
      className="artist-tooltip"
      style={{ left: clientX + 12, top: clientY + 12 }}
    >
      <div className="title">{node.artist_name}</div>
      <div className="field">
        <span className="label">Stage:</span>
        <b>{node.career_stage}</b>
      </div>
      {spotifyGenres.length > 0 && (
        <div className="field">
          <div className="label">Spotify</div>
          <div className="genres">
            {spotifyGenres.map((g) => (
              <span key={g} className="genre spotify">
                {g}
              </span>
            ))}
          </div>
        </div>
      )}
      {strmGenres.length > 0 && (
        <div className="field">
          <div className="label">STRM</div>
          <div className="genres">
            {strmGenres.map((g) => (
              <span key={g} className="genre strm">
                {g}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
